(function () {
    "use strict";

    angular.module("app").controller("ConfirmScreeningResultsController", ConfirmScreeningResultsController);

    ConfirmScreeningResultsController.$inject = ["controllerDecorator", "apiClientFactory", "$timeout",];
    function ConfirmScreeningResultsController(controllerDecorator, apiClientFactory, $timeout) {
        const resultCodes = {
            Success: 0,
            Failure: 1,
            UnhandledException: 2
        };

        const confirmActions = {
            assistanceIn: "assistance_in",
            installations: "installations",
            cis: "cis",
            fsc: "fvm",
            fscReturns: "fsc-return",
            psc: "ivm",
            pscReinvestigations: "psc-reinvestigations",
        };

        let context = {
            action: null,
        };

        const vm = this;

        controllerDecorator.Decorate(vm, ["navigation", "files",]);

        vm.SetLoadingState(false);

        vm.initialize = initialize;
        vm.actionDescription = "";

        vm.assistanceInLetters = {
            any() {
                if (!vm.signingResult)
                    return false;

                // Explicitly the check to a boolean
                return !!vm.signingResult.ResultLetters;
            },
            download() {
                // DOWNLOAD and redirect
                vm.File.Save(vm.signingResult.ResultLetters.Content, vm.signingResult.ResultLetters.Name);
                redirect(vm.redirectUrl);
            },
        };

        function initialize(confirmAction) {

            context.action = confirmAction;
            vm.actionDescription = getActionDescription(confirmAction);

            vm.isSigning = true;

            apiClientFactory.post("Screenings/Confirm")(
                {},
                r => {
                    vm.signingResult = r.data;
                    vm.redirectUrl = r.headers("Location");

                    switch (vm.signingResult.ResultCode) {
                        case resultCodes.Success:
                            handleSuccess();
                            break;
                        case resultCodes.UnhandledException:
                            vm.ShowError(vm.getTranslation("Unexpected_Error_Message"));
                            break;
                    }
                },
                vm.ShowError,
                () => vm.isSigning = false,
            );
        }

        function getActionDescription(signingAction) {
            switch (signingAction) {
                case confirmActions.assistanceIn:
                    return vm.getTranslation("ConfirmScreeningResults_AssistanceIn");
                case confirmActions.installations:
                    return vm.getTranslation("ConfirmScreeningResults_Installation");
                case confirmActions.cis:
                    return vm.getTranslation("ConfirmScreeningResults_Cis");
                case confirmActions.fsc:
                    return vm.getTranslation("ConfirmScreeningResults_Fsc");
                case confirmActions.fscReturns:
                    return vm.getTranslation("ConfirmScreeningResults_FscReturns");
                case confirmActions.psc:
                    return vm.getTranslation("ConfirmScreeningResults_Psc");
                case confirmActions.pscReinvestigations:
                    return vm.getTranslation("ConfirmScreeningResults_PscReinvestigation");
            }
        }

        function handleSuccess() {
            if (context.action === confirmActions.assistanceIn && vm.assistanceInLetters.any())
                return;

            vm.redirectEnabled = true;
            $timeout(redirect, 10000 /* ms */, true, vm.redirectUrl);
        }

        function redirect(url) {
            vm.Navigator.OpenUrl(url);
        }
    }
})();
